module.exports = __webpack_public_path__ + "static/media/P37.4addbf8e.jpg";